export enum ProductPackageCodeEnum {
  SUBSCRIPTION_MINI = 'SUBSCRIPTION_MINI',
  SUBSCRIPTION_PRO = 'SUBSCRIPTION_PRO',
  SUBSCRIPTION_STARTER = 'SUBSCRIPTION_STARTER',
}
